export const RESTAURANT_LOCATIONS = [
  { 
    id: "olofstrom", 
    name: "Olofström", 
    address: "Centrum, Olofström" 
  },
  { 
    id: "karlshamn", 
    name: "Karlshamn", 
    address: "Torget, Karlshamn" 
  }
  // To add a new restaurant, just add it here! 
  // Example: 
  // { id: "malmo", name: "Malmö", address: "Stortorget, Malmö" }
];
